import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import {Title} from "@angular/platform-browser";
import { staticsService } from 'src/app/shared/services/statics.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutusComponent implements OnInit {
  section:any;
  pagedata
  mobView: boolean = false
  imageUrl = environment.imagesUrl+"statics/";
  yourGoToHubDesc : string = "For over two decades, Cairo Jazz Club has stood the test of time as the country’s ultimate live entertainment hub. It has served as Cairo's trusty live music venue, go-to nightlife spot, and friendly bar next door. The venues continue to maintain a lively and engaging atmosphere where people can enjoy live entertainment and delicious food and cocktails, all while feeling right at home.";

  constructor(private titleService:Title , private staticsService : staticsService ,
    @Inject(PLATFORM_ID) private platformId: any 
  ) { }

  ngOnInit(): void {
    this.getdata()
    this.titleService.setTitle("About CJC - Cairo Jazz Club");
    this.staticsService.updateMobileTitle("About CJC");

    if (isPlatformBrowser(this.platformId)) {
      this.detectMobView();
    }
  }
  detectMobView() {
    if (window.innerWidth < 767) {
      this.mobView = true;
      console.log(this.mobView);
    }
  }
  getdata(){
    this.staticsService.getAboutUsStatics().subscribe(res => {
      this.section = res.banner;
    });
  }
}
